// A conceptual flow of research threads converging into a reviewed decision.
export const bootcampWorkflowShader = /* wgsl */ `
struct Params { time: f32, stage: f32, aspect: f32, pointer: f32, ink: vec3f }
@group(0) @binding(0) var<uniform> params: Params;
@fragment fn fs_main(@location(0) uv: vec2f) -> @location(0) vec4f {
  let x = uv.x;
  let px = fwidth(uv.y);
  var coverage = 0.0;
  var accent = 0.0;
  let envelope = pow(max(0.0, sin(x * 3.14159265)), 0.8);
  for (var i = 0; i < 22; i = i + 1) {
    let lane = f32(i) / 21.0;
    let spread = mix(0.40, 0.12, params.stage / 2.0);
    let turn = x * 7.0 + lane * 5.8 + params.time * 0.22;
    let y = 0.5 + envelope * ((lane - 0.5) * spread + sin(turn) * 0.20)
      + params.pointer * (x - 0.5) * 0.12;
    let line = 1.0 - smoothstep(px * 0.55, px * 1.6, abs(uv.y - y));
    let edge = smoothstep(0.03, 0.13, x) * (1.0 - smoothstep(0.87, 0.97, x));
    coverage = max(coverage, line * edge * (0.3 + lane * 0.45));
    let travel = fract(params.time * 0.065 + lane * 0.17);
    let segment = smoothstep(travel - 0.09, travel - 0.06, x) * (1.0 - smoothstep(travel, travel + 0.02, x));
    accent = max(accent, line * edge * segment);
  }
  let color = mix(params.ink, vec3f(0.72, 0.39, 0.12), accent);
  let alpha = max(coverage, accent);
  return vec4f(color * alpha, alpha);
}
`;
